// import { fpjsPlugin, defaultEndpoint } from '@fingerprintjs/fingerprintjs-pro-vue-v2'
import * as analyticTracking from '@/mixins/analytic-tracking'
import * as constants from '@/mixins/constants'
import { globalComputed, globalMethods } from '@/mixins/globalMixin'
import * as trackingEvents from '@/mixins/tracking-events'
import i18next from '@/plugins/i18next'
import store from '@/store'
import VueI18Next from '@panter/vue-i18next'
import axios from 'axios'
import * as Comlink from 'comlink'
import IScroll from 'iscroll'
import MobileDetect from 'mobile-detect'
import moment from 'moment'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueCookie from 'vue-cookie'
import vueHeadful from 'vue-headful'
import infiniteScroll from 'vue-infinite-scroll'
import IScrollView from 'vue-iscroll-view'
import VueNumeric from 'vue-numeric'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import MainWorker from '../utils/workers/web-workers/main.worker.js'
import App from './App.vue'
import router from './router'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import '@/utils/gtm.js'
import { stringEscape } from '@/plugins/util.js'

Vue.use(VueDOMPurifyHTML, {
  hooks: {
    afterSanitizeAttributes: (currentNode) => {
      if ('target' in currentNode) {
        currentNode.setAttribute('target', '_blank')
        currentNode.setAttribute('rel', 'noopener')
      }
    }
  }
})

Vue.use(VueI18Next)
const i18n = new VueI18Next(i18next)

axios.defaults.baseURL = process.env.API_URL
axios.interceptors.request.use(
  function (config) {
    if (!config.timeout) {
      config.timeout = 20000
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)
Vue.use(VueAxios, axios)

Vue.use(Vuetify, {
  theme: {
    primary: '#1e2026', // '#142246' '#2C3E50'
    secondary: '#FF9800',
    accent: '#f37336', // '#f37336'
    success: '#47b04b'
  }
})
Vue.use(VueCookie)

Vue.use(VueNumeric)

Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.prototype.$constants = constants
Vue.prototype.$mobileDetect = new MobileDetect(window.navigator.userAgent)

Vue.use(infiniteScroll)

// Vue.use(fpjsPlugin, {
//   loadOptions: {
//     apiKey: process.env.VUE_APP_FINGERPRINT_KEY,
//     endpoint: [defaultEndpoint],
//     region: 'ap'
//   }
// })

// Integrate Sentry
// sentry(Vue, PARTNER_SENTRY_CONFIG)

Vue.mixin({
  methods: globalMethods,
  computed: globalComputed
})

Vue.directive('img-fallback', function (el, binding) {
  let original = el.src
  let img = new Image()
  img.src = original
  img.onerror = () => {
    el.src = binding.value
  }
})
Vue.directive('img-fallback-text', function (el, binding) {
  let original = el.src
  let img = new Image()
  img.src = original
  img.onerror = () => {
    if (binding.value) {
      const words = binding.value.split(' ')
      const name = `${words[0].substr(0, 1)}${words[1] ? words[1].substr(0, 1) : ''}`
      el.replaceWith(name)
    }
  }
})

// Vue.directive("custom-click-outside", {
//   // https://jsfiddle.net/Linusborg/Lx49LaL8/
//   bind: function(el, binding, vNode) {
//     // Provided expression must evaluate to a function.
//     if (typeof binding.value !== "function") {
//       const compName = vNode.context.name;
//       let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
//       if (compName) {
//         warn += `Found in component '${compName}'`;
//       }
//       console.warn(warn);
//     }
//     // Define Handler and cache it on the element
//     const bubble = binding.modifiers.bubble;
//     const handler = e => {
//       if (bubble || (!el.contains(e.target) && el !== e.target)) {
//         binding.value(e);
//         if (e.stopPropagation) {
//           e.stopPropagation();
//         }
//       }
//     };
//     el.__vueClickOutside__ = handler;

//     // add Event Listeners
//     document.addEventListener("click", handler, true);
//   },
//   unbind: function(el) {
//     // Remove Event Listeners
//     document.removeEventListener("click", el.__vueClickOutside__, true);
//     el.__vueClickOutside__ = null;
//   }
// });

Vue.directive('custom-click-outside', {
  // https://jsfiddle.net/Linusborg/Lx49LaL8/
  bind: function (el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
      if (compName) {
        warn += `Found in component '${compName}'`
      }
      console.warn(warn)
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e)
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
    }
    el.__vueClickOutside__ = handler

    // add Event Listeners
    document.addEventListener('click', handler, { passive: true })
  },
  unbind: function (el) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__, true)
    el.__vueClickOutside__ = null
  }
})

Vue.prototype.$trackingEvents = trackingEvents
Vue.prototype.$analyticTracking = analyticTracking

Vue.prototype.$stringEscape = stringEscape

var PromiseWorker = require('promise-worker')
const worker = new Worker('/assets/js/worker.js?version=1')
Vue.prototype.$promiseWorker = new PromiseWorker(worker)

const mainWorker = new MainWorker()
Vue.prototype.$mainWorker = Comlink.wrap(mainWorker)
window.$mainWorker = Vue.prototype.$mainWorker

moment.locale(store.state.locale)
Vue.prototype.$moment = moment

Vue.component('vue-headful', vueHeadful)

Vue.use(IScrollView, IScroll)

if (!window.Velocity) {
  window.Velocity = (el, props, options) => {
    if (options && options.complete) {
      options.complete()
    }
  }
}

Vue.prototype.$_VUE_APP_REST_API = process.env.VUE_APP_REST_PARTNER_API
global.$_VUE_APP_REST_API = Vue.prototype.$_VUE_APP_REST_API // set global variable to support in not Vue component case
Vue.prototype.$_VUE_APP_REST_GW_MAP_API = process.env.VUE_APP_REST_GW_MAP_API
global.$_VUE_APP_REST_GW_MAP_API = Vue.prototype.$_VUE_APP_REST_GW_MAP_API
Vue.prototype.$_PAGE = constants.PAGE.PARTNER
Vue.prototype.$_VUE_APP_DOMAIN =
  process.env.VUE_APP_DOMAIN === 'localhost' ? 'localhost' : 'onwheel.io'

// /* webpackChunkName: "svg-icon" */
const SvgIcon = () => import('@/components/SvgIcon')
Vue.component('SvgIcon', SvgIcon)

Vue.ignoredElements = ['iframe']

Vue.filter('onlyStaging', function (value) {
  if (process.env.VUE_APP_IS_PRODUCTION) {
    return null
  }

  return value
})

new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: (h) => h(App)
}).$mount('#app')
